import { patchEnzuzoA11y } from "../utilities/Helpers/UI/EnzuzoA11y";

// Loaded only by sections/page__main.liquid, and only when the page body
// embeds Enzuzo (`#__enzuzo-root`), so the patch stays out of main.js and off
// every other page. Enzuzo renders client-side, so the patch's own observer
// handles the widget appearing later.
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => patchEnzuzoA11y());
} else {
    patchEnzuzoA11y();
}
